import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { BodyInquilino } from 'src/app/interfaces/bodyInquilino';
import { CiudadesModels } from 'src/app/models/ciudades';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { MENSAJE_PROPIETARIO, TIEMPO_INACTIVO } from 'src/app/routes.constants';
import { CiudadesService } from 'src/app/services/cuidades/ciudades.service';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-datos-inquilino-inicial',
  standalone: false,
  templateUrl: './datos-inquilino-inicial.component.html',
  styleUrl: './datos-inquilino-inicial.component.scss'
})
export class DatosInquilinoInicialComponent implements OnInit {
  @ViewChild('primerNombre') primerNombre!: ElementRef;
  @ViewChild('numCelular') numCelular!: ElementRef;
  @ViewChild('correo') correoElec!: ElementRef;

  public modelSalida!: NgbDateStruct;
  public modelRegreso!: NgbDateStruct;
  parametro: string = '';
  emailPattern = environment.PATTERN_EMAIL;
  celularPattern = environment.PATTERN_CELULAR;
  identPatter = environment.PATTERN_IDENTIFICACION
  json: string = '';
  jsonFinal: string = '';
  mensajeAlerta: string = '';
  swAlerta: boolean = false;
  minutos: number = 0;
  segundos: number = 0;
  id: any;
  swHabilitaBoton: boolean = false;
  dato1: string = '';
  dato2: string = '';
  dato3: string = '';
  dato4: string = '';
  completo: string[] = [];
  nombrePantalla: string = '';
  planSeleccionado: string = '';
  ngSelect = "CO";
  ngSelectTI: string = 'C';
  swLlenaDatos: boolean = false;
  states: string[] = [];
  ciudades: CiudadesModels[] = [];
  ciudadSeleccionada: string = '';
  sessionId: string = '';
  editable: boolean = true;
  today = new Date();
  pipe = new DatePipe('en-US');
  fechaActual = this.pipe.transform(this.today, 'dd/MM/YYYY')

  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  // Intervalo para detectar movimiento del cursor
  isMouseMove: any;
  checador: any;
  saliendo: boolean = false;
  leadId: string = '';

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
    this.isActivity = true;
    nuevaPosicionX = e.clientX;
    nuevaPosicionY = e.clientY;

    if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
      clearTimeout(this.checador);
      this.checador = setTimeout(() => {

        if (this.saliendo == false) {
          this.isActivity = false;
          this.saliendo = true;
          clearInterval(this.isMouseMove);
          clearTimeout(this.checador);
          this.router.navigate([TIEMPO_INACTIVO, { idLead: this.leadId, porcPll: '95', msnPll: 'Inactividad Datos inquilino', infoViaje: btoa(this.parametro) }]);
        }
      }, this.localTimer);
    }

    posicionX = e.clientX;
    posicionY = e.clientY;
  }

  regExp = RegExp(this.celularPattern);
  regExpIdent = RegExp(this.identPatter);
  regExpTextos = RegExp('[a-z, ñÑ, íÍ, óÓ, áÁ, éÉ, úÚ]');

  formulario: FormGroup = new FormGroup(
    {
      primerNombre: new FormControl('', [Validators.required]),
      numCelular: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]),
      correo: new FormControl('', [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]),
    }
  );

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  datosEnvio: BodyInquilino = {
    SessionId: '',
    leadId: '',
    asesorCode: '',
    bitacoraId: '',
    productFamily: '',
    screenPercentage: '',
    productsConfigurationData: {
      ProductCode: '',
      PolicyHolder: {
        LastName: '',
        CountryOfBirth: '',
        DocumentNumber: '',
        DocumentType: '',
        ExpeditionDate: '',
        FirstName: '',
        Mail: '',
        MobilePhone: '',
        PersonalDataAuthorization: false,
        PersonalDataLastUpdated: '',
        PersonalDataVersion: '',
        SecondLastName: '',
        SecondName: ''
      },
      Property: {
        AdministrationValue: 0,
        ContractStartDate: '',
        Department: '',
        RentalFee: 0,
        TemporaryContracted: '',
        UseProperty: '',
        CityProperty: '',
        RealEstateLicensePlate: '',
        PropertyAddress: ''
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: '',
        PersonalDataVersion: '',
        PersonalDataLastUpdated: '',
        PersonalDataAuthorization: false,
        MobilePhone: '',
        Mail: '',
        ExpeditionDate: '',
        CountryOfBirth: '',
        SecondLastName: '',
        LastName: '',
        SecondName: '',
        FirstName: ''
      }
    }
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private servicioCiudades: CiudadesService,
    private orquestadorService: OrquestadorService
  ) {
    this.minutos = 0;
    this.segundos = 8;
  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  @Input() infoCliente?: string;
  @Input() idLead?: string;

  ngOnInit(): void {
    this.localTimer = environment.LOCAL_TIMER;
    this.sessionId = this.getLocalStorage().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);
        this.formulario.get("documentoIdentidad")?.setValue(this.datosGenerales.Cliente.cedulaCliente);
      }
      else {
        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);
          this.parametro = JSON.stringify(this.datosGenerales);

          this.formulario.get("primerNombre")?.setValue(this.datosGenerales.Inquilino.primerNombre);
          this.formulario.get("numCelular")?.setValue(this.datosGenerales.Inquilino.numCelular);
          this.formulario.get("correo")?.setValue(this.datosGenerales.Inquilino.correo);
        }
      }
    });
  }

  valPrimerNombre = false;
  valPrimerNombre2 = true;
  validacionPrimerNombre() {
    if (this.formulario.get("primerNombre")?.value === '') {
      this.valPrimerNombre = !this.valPrimerNombre;
      this.valPrimerNombre2 = !this.valPrimerNombre2;
    } else if (!this.regExpTextos.test(this.formulario.get("primerNombre")?.value)) {
      this.valPrimerNombre = !this.valPrimerNombre;
      this.valPrimerNombre2 = !this.valPrimerNombre2;
    } else {
      this.valPrimerNombre = false;
      this.valPrimerNombre2 = true;
    }
  }

  valCelular = false;
  valCelular2 = true;
  validacionCelular() {
    if (this.formulario.get("numCelular")?.value === '') {
      this.valCelular = !this.valCelular;
      this.valCelular2 = !this.valCelular2;
    } else if (!this.regExp.test(this.formulario.get("numCelular")?.value)) {
      this.valCelular = !this.valCelular;
      this.valCelular2 = !this.valCelular2;
    } else {
      this.valCelular = false;
      this.valCelular2 = true;
    }
  }

  valEmail = false;
  valEmail2 = true;
  validacionEmail() {
    if (this.formulario.get("correo")?.value === '') {
      this.valEmail = !this.valEmail;
      this.valEmail2 = !this.valEmail2;
    } else {
      this.valEmail = false;
      this.valEmail2 = true;
    }
  }


  get nombrePrimerNoValido() {
    return this.formulario.get("primerNombre")?.invalid
      && this.formulario.get("primerNombre")?.touched;
  }

  get correoNoValido() {
    return this.formulario.get("correo")?.invalid
      && this.formulario.get("correo")?.touched;
  }

  get cedularNoValido() {
    if (this.formulario.get("numCelular")?.value !== '') {
      if (!this.regExp.test(this.formulario.get("numCelular")?.value)) {
        if (this.valCelular) {
          return false
        }
        return true;
      }
    }
    return false;
  }

  get formularioNoValido() {
    return this.formulario.invalid
  }

  Validaciones() {
    this.datosGenerales.Inquilino.primerNombre = this.formulario.get("primerNombre")?.value;
    this.datosGenerales.Inquilino.numCelular = this.formulario.get("numCelular")?.value;
    this.datosGenerales.Inquilino.correo = this.formulario.get("correo")?.value;
    this.parametro = JSON.stringify(this.datosGenerales);

    this.GuardarDataLayer();
    this.router.navigate([MENSAJE_PROPIETARIO, { idLead: this.leadId, infoCliente: btoa(this.parametro) }]);
  }

  private GuardarDataLayer() {
    const datepipe: DatePipe = new DatePipe('en-US')
    let formattedDate = datepipe.transform(Date.now(), 'dd/MM/YYYY');

    this.datosEnvio.SessionId = this.sessionId;
    this.datosEnvio.leadId = this.leadId;
    this.datosEnvio.productFamily = 'Arrendamientos'
    this.datosEnvio.screenPercentage = '95';

    this.datosEnvio.productsConfigurationData.ProductCode = this.datosGenerales.PlanSeleccionado.plan
    this.datosEnvio.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Propietario.primerApellido;
    this.datosEnvio.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente;
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion = this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataVersion;
    this.datosEnvio.productsConfigurationData.PolicyHolder.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
    this.datosEnvio.productsConfigurationData.PolicyHolder.FirstName = this.datosGenerales.Propietario.primerNombre;
    this.datosEnvio.productsConfigurationData.PolicyHolder.Mail = this.datosGenerales.Propietario.correo;
    this.datosEnvio.productsConfigurationData.PolicyHolder.ExpeditionDate = this.datosGenerales.Propietario.fechaExpedicion;
    this.datosEnvio.productsConfigurationData.PolicyHolder.DocumentNumber = this.datosGenerales.Propietario.numeroIdentificacion;
    this.datosEnvio.productsConfigurationData.PolicyHolder.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
    this.datosEnvio.productsConfigurationData.PolicyHolder.CountryOfBirth = this.datosGenerales.Propietario.paisNacimiento;
    this.datosEnvio.productsConfigurationData.PolicyHolder.SecondLastName = this.datosGenerales.Propietario.segundoApellido;
    this.datosEnvio.productsConfigurationData.PolicyHolder.SecondName = this.datosGenerales.Propietario.segundoNombre;

    this.datosEnvio.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente;
    this.datosEnvio.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Inquilino.tipoidentificacion;
    this.datosEnvio.productsConfigurationData.Tenant.PersonalDataVersion = this.datosEnvio.productsConfigurationData.Tenant.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosEnvio.productsConfigurationData.Tenant.PersonalDataVersion;
    this.datosEnvio.productsConfigurationData.Tenant.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
    this.datosEnvio.productsConfigurationData.Tenant.PersonalDataAuthorization = true;
    this.datosEnvio.productsConfigurationData.Tenant.MobilePhone = this.datosGenerales.Inquilino.numCelular;
    this.datosEnvio.productsConfigurationData.Tenant.Mail = this.datosGenerales.Inquilino.correo;
    this.datosEnvio.productsConfigurationData.Tenant.ExpeditionDate = this.datosGenerales.Inquilino.fechaExpedicion;
    this.datosEnvio.productsConfigurationData.Tenant.CountryOfBirth = this.datosGenerales.Inquilino.paisNacimento;
    this.datosEnvio.productsConfigurationData.Tenant.SecondLastName = this.datosGenerales.Inquilino.segundoApellido;
    this.datosEnvio.productsConfigurationData.Tenant.LastName = this.datosGenerales.Inquilino.primerApellido;
    this.datosEnvio.productsConfigurationData.Tenant.SecondName = this.datosGenerales.Inquilino.segundoNombre;
    this.datosEnvio.productsConfigurationData.Tenant.FirstName = this.datosGenerales.Inquilino.primerNombre;

    this.datosEnvio.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.datosEnvio.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.datosEnvio.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
    this.datosEnvio.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
    this.datosEnvio.productsConfigurationData.Property.ContractStartDate = this.datosGenerales.InfoArrendamiento.fechaContrato;
    this.datosEnvio.productsConfigurationData.Property.CityProperty = this.datosGenerales.Inmueble.ciudad;
    this.datosEnvio.productsConfigurationData.Property.RealEstateLicensePlate = this.datosGenerales.Inmueble.maticula;
    this.datosEnvio.productsConfigurationData.Property.PropertyAddress = this.datosGenerales.Inmueble.direccion;

    this.orquestadorService.postOrquestadorDatosInquilino(this.datosEnvio).
      subscribe(
        (data) => {
          const response = data;
        }
      );
  }
}
